import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {OrganizationService} from '../services/organization.service';
import {AuthService} from '../services/auth.service';

// Visual gate: if the current org's billing_status is not 'active', redirect to /assinatura.
// SuperAdmins bypass so they can fix the flag via /admin. The 402 response from the backend
// is the authoritative block — this guard short-circuits the navigation when status is already known.
export const subscriptionGuard: CanActivateFn = () => {
  const organizationService = inject(OrganizationService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.loggedUser()?.superAdmin) {
    return true;
  }

  const status = organizationService.lastBillingStatus()
    ?? organizationService.currentOrganization()?.billingStatus;

  if (status && status !== 'active') {
    router.navigate(['/assinatura']);
    return false;
  }
  return true;
};
